<template>
  <div class="cash-withdrawal">

    <div class="my-promotion">
      <div class="header"style="background-color: #ec5d59 !important;">
        <div class="name acea-row row-center-wrapper">
          <div>累计提现</div>
        </div>
        <div class="num"><span  style="font-size:0.4rem;">已审:</span>{{extract_money || 0}} <span style="font-size:0.4rem;">待审:</span>{{extract_will_money || 0}}</div>
        <div class="name acea-row row-center-wrapper">
          <div>{{transfer_name}}余额</div>
        </div>
        <div class="num">{{commissionCount || 0}}</div>
      </div>
    </div>
    <div class="bill-details">
      <div class="nav acea-row">
        <div class="item on"  >
          提现
        </div>
        <div class="item" @click="toCommissionList()" >
          提现记录
        </div>
      </div>
    </div>

    <div class="nav acea-row" style="display:none;">
      <div
        v-for="(item, index) in navList"
        class="item font-color-red"
        @click="swichNav(index, item)"
        :key="index"

      >
        <div
          class="line bg-color-red"
          :class="currentTab === index ? 'on' : ''"
        ></div>
        <div
          class="iconfont"
          :class="item.icon + ' ' + (currentTab === index ? 'on' : '')"
        ></div>
        <div>{{ item.name }}</div>
      </div>
    </div>
    <div class="wrapper"  style="background-color:#fff;">
      <div :hidden="currentTab !== 0" class="list">

        <div class="item acea-row row-between-wrapper">
          <div class="name">选择账户</div>
          <div class="input">
            <select  v-model="post.extract_field" @change='extractType'>
              <option
                  v-for="(text, index) in transferType"
                  :value="index"
                  :key="index"
              >
                {{ text }}
              </option>
            </select>

          </div>
        </div>
        <div class="item acea-row row-between-wrapper">
          <div class="name">提现金额</div>
          <div class="input">
            <input
                :placeholder="post.placeholder"
                v-model="post.money"

                @blur="getMoney()"
            />
          </div>
        </div>
        <div class="tip" style="color:red;">服务费：{{all_fee}}元 实到账：{{get_money}}元</div>

        <div class="item acea-row row-between-wrapper">
          <div class="name">持卡姓名</div>
          <div class="input">
            <input placeholder="请输入持卡人姓名" v-model="post.name" maxlength="12" />
          </div>
        </div>

        <div class="item acea-row row-between-wrapper">
          <div class="name">身份证号</div>
          <div class="input">
            <input placeholder="请输入持卡人身份证" v-model="post.card_idcard" maxlength="18" />
          </div>
        </div>

        <div class="item acea-row row-between-wrapper">
          <div class="name">手机号码</div>
          <div class="input">
            <input placeholder="请输入持卡人手机号" v-model="post.card_mobile" maxlength="11" />
          </div>
        </div>

        <div class="item acea-row row-between-wrapper">
          <div class="name">银行卡号</div>
          <div class="input">
            <input placeholder="请填写卡号" v-model="post.cardnum" maxlength="19" />
          </div>
        </div>
        <div class="item acea-row row-between-wrapper">
          <div class="name">银行名称</div>
          <div class="input">
            <select v-model="post.bankname">
              <option value="">请选择银行</option>
              <option
                v-for="(item, index) in banks"
                :key="index"

                v-bind:value="item"
                >{{ item }}</option>
            </select>
          </div>
        </div>

        <div class="tip" v-if="err_text !== ''" style="color:red;">{{err_text}}</div>

      <div class="bnt bg-color-red" @click="submitted">提现</div>
      </div>
      <div :hidden="currentTab !== 2" class="list">
        <div class="item acea-row row-between-wrapper">
          <div class="name">微信号</div>
          <div class="input">
            <input placeholder="请输入微信号" v-model="post.weixin" />
          </div>
        </div>
        <div class="item acea-row row-between-wrapper">
          <div class="name">提现</div>
          <div class="input">
            <input
              :placeholder="'最低提现金额' + minPrice"
              v-model="post.money"
            />
          </div>
        </div>
        <div class="bnt bg-color-red" @click="submitted">提现</div>
      </div>
      <div :hidden="currentTab !== 1" class="list">
        <div class="item acea-row row-between-wrapper">
          <div class="name">会员号</div>
          <div class="input">
            <input placeholder="请填写您的支付宝会员号" v-model="post.name" />
          </div>
        </div>

        <div class="item acea-row row-between-wrapper">
          <div class="name">账号</div>
          <div class="input">
            <input
              placeholder="请填写您的支付宝账号"
              v-model="post.alipay_code"
            />
          </div>
        </div>

        <div class="item acea-row row-between-wrapper">
          <div class="name">身份证</div>
          <div class="input">
            <input placeholder="请输入身份证" v-model="post.card_idcard" maxlength="18" />
          </div>
        </div>

        <div class="item acea-row row-between-wrapper">
          <div class="name">手机号</div>
          <div class="input">
            <input placeholder="请输入手机号" v-model="post.card_mobile" maxlength="11" />
          </div>
        </div>


        <div class="item acea-row row-between-wrapper">
          <div class="name">提现</div>
          <div class="input">
            <input
              :placeholder="'最低提现金额' + minPrice"
              v-model="post.money"
            />
          </div>
        </div>
        <div class="tip">身份证、手机号、持卡人身份需一致</div>

        <div class="bnt bg-color-red" @click="submitted">提现</div>
      </div>
    </div>
  </div>
</template>
<script>
import { getBank, postCashInfo,getMoney } from "../../../api/user";
import { required } from "@utils/validate";
import { validatorDefaultCatch } from "@utils/dialog";

export default {
  name: "UserCash",
  components: {},
  props: {},
  data: function() {
    return {
      navList: [
        { name: "银行卡", type: "bank", icon: "icon-yinhangqia" },
        //{ name: "支付宝", type: "alipay", icon: "icon-icon34" }
        //{ name: "微信", type: "weixin", icon: "icon-weixin2" },

      ],
      post: {
        extract_type: "bank",
        alipay_code: "",
        money: "",
        name: "",
        bankname: "",
        cardnum: "",
        extract_field:"",
        weixin: "",
        card_idcard:"",
        card_mobile:"",
        placeholder:"",
      },
      extract_money:0,
      extract_will_money:0,
      currentTab: 0,
      minPrice: 0,
      get_money:0,
      shui:0,
      user:[],
      fee:0,
        all_fee:0,
      banks: [],
      transferType:[],
      commissionCount: 0,
      err_text:'',
    };
  },
    watch: {
        $route(n) {
            if (n.name == "UserCash") {
              if(this.$route.params.types){
                this.post.extract_field = this.$route.params.types;
              }
                this.getBank();
            }
        }
    },
  mounted: function() {
    if(this.$route.params.types){
      this.post.extract_field = this.$route.params.types;
    }
    this.getBank();
  },
  methods: {
    toCommissionList(){
      this.$router.push({path:'/user/cashrecord/'+this.post.extract_field})
    },
    swichNav: function(index, item) {
      this.currentTab = index;
      this.post.extract_type = item.type;
    },
    getMoney: function() {
      let that = this,money = Number(that.post.money),extract_field=that.post.extract_field;
      if(money!=0) {
        getMoney(
                {
                  'money': money,
                  'extract_field':extract_field
                }
        ).then(
                res => {
                  that.get_money = res.data.get_money;
                  that.all_fee = res.data.all_fee;
                },
                err => {
                  that.$dialog.message(err.msg);
                }
        );
      }
    },
    extractType:function(){
      this.commissionCount =this.user[this.post.extract_field];
    },
    getBank: function() {
      let that = this;
      getBank().then(
        res => {
          that.banks = res.data.extractBank;
          that.minPrice = res.data.minPrice;
          that.fee = res.data.fee;
          that.shui = res.data.shui;
          that.user = res.data.user;

          that.err_text = res.data.err_text;


          if(that.post.extract_field==''){
            that.post.extract_field = res.data.extract_field;
          }
          that.extract_money = res.data.extract_money;
          that.extract_will_money = res.data.extract_will_money;
          that.commissionCount = res.data.user[that.post.extract_field];
          that.transfer_name = res.data.transferType[that.post.extract_field];

          that.transferType = res.data.transferType;
          that.post.name = res.data.bank_name;
          that.post.alipay_code = res.data.alipay_code;
          that.post.bankname = res.data.bank_address;
          that.post.cardnum = res.data.bank_code;
          that.post.weixin = res.data.weixin;
          that.post.card_idcard = res.data.card_idcard;
          that.post.card_mobile = res.data.card_mobile;
          that.post.placeholder = res.data.placeholder;
        },
        function(err) {
          that.$dialog.message(err.msg);
        }
      );
    },
    async submitted() {
      let bankname = this.post.bankname,
        alipay_code = this.post.alipay_code,
        money = this.post.money,
        name = this.post.name,
        cardnum = this.post.cardnum,
        weixin = this.post.weixin,
              card_idcard = this.post.card_idcard,
              card_mobile = this.post.card_mobile,
          extract_field = this.post.extract_field,
        that = this;
      if (
        parseFloat(money) > parseFloat(that.commissionCount) ||
        parseFloat(that.commissionCount) == 0
      )
        return that.$dialog.message("余额不足");
      if (parseFloat(money) < parseFloat(that.minPrice))
        return that.$dialog.message("最低提现金额" + that.minPrice);
      switch (that.post.extract_type) {
        case "bank":
          try {
            await this.$validator({
              name: [required.message("持卡人姓名")],
              cardnum: [required.message("卡号")],
              bankname: [required.message("请选择提现银行")],
              money: [required.message("提现金额")],
              card_idcard: [required.message("身份证")],
              card_mobile: [required.message("手机号")]
            }).validate({ bankname, cardnum, name, money });
            let save = {
              extract_type: that.post.extract_type,
              bankname: bankname,
              cardnum: cardnum,
              name: name,
              money: money,
              extract_field:extract_field,
              card_idcard:card_idcard,
              card_mobile:card_mobile
            };
            that.save(save);
          } catch (e) {
            return validatorDefaultCatch(e);
          }
          break;
        case "alipay":
          try {
            await this.$validator({
              name: [required(required.message("支付宝会员号"))],
              alipay_code: [required(required.message("支付宝账号"))],
              money: [required(required.message("提现金额"))]
            }).validate({ name, alipay_code, money });
            let save = {
              extract_type: that.post.extract_type,
              alipay_code: alipay_code,
              name: name,
              money: money
            };
            that.save(save);
          } catch (e) {
            return validatorDefaultCatch(e);
          }
          break;
        case "weixin":
          try {
            await this.$validator({
              weixin: [required(required.message("提现微信号"))],
              money: [required(required.message("提现金额"))]
            }).validate({ weixin, money });
            let save = {
              extract_type: that.post.extract_type,
              weixin: weixin,
              money: money
            };
            that.save(save);
          } catch (e) {
            return validatorDefaultCatch(e);
          }
          break;
      }
    },
    save: function(info) {
      postCashInfo(info).then(
        res => {
          this.$dialog.message(res.msg);
          this.$router.push({ path: "/user/cashrecord/"+this.post.extract_field });
        },
        error => {
          this.$dialog.message(error.msg);
        }
      );
    }
  }
};
</script>
